"use client";

import React, { useState } from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Separator } from "@/components/ui/separator";
import { Loader, Mail, Phone, User, Info } from "lucide-react";
export default function ContactForm() {
  return <section id="kontaktní-formulář" className="dark bg-background text-foreground py-24 px-4">
      <div className="max-w-7xl mx-auto">
        <div id="contact" className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-display mb-2 tracking-tight">
                Kontaktní formulář
              </h2>
              <p className="text-muted-foreground text-lg">
                Napište nám a my se vám ozveme co nejdříve
              </p>
            </div>

            <div className="space-y-6">
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <User className="size-5 text-primary" />
                  <div>
                    <p className="text-sm text-muted-foreground uppercase tracking-wide">Kontaktní osoba</p>
                    <p className="text-lg font-medium">René Salva</p>
                  </div>
                </div>
                <Separator className="bg-primary h-[1px]" />
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <Phone className="size-5 text-primary" />
                  <div>
                    <p className="text-sm text-muted-foreground uppercase tracking-wide">Telefon</p>
                    <p className="text-lg font-medium">+420 732 438 067</p>
                  </div>
                </div>
                <Separator className="bg-primary h-[1px]" />
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <Mail className="size-5 text-primary" />
                  <div>
                    <p className="text-sm text-muted-foreground uppercase tracking-wide">E-mail</p>
                    <p className="text-lg font-medium break-all">cisteni.renovacestrech@gmail.com</p>
                  </div>
                </div>
                <Separator className="bg-primary h-[1px]" />
              </div>
            </div>
          </div>

          <FormProvider className="space-y-6" formId="contact_form_contact" sectionName="contact-form" defaultValues={{
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: ""
        }} validationRules={{
          name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            pattern: "phone"
          },
          subject: {
            required: true
          },
          message: {
            required: true,
            minLength: 20,
            maxLength: 2000
          }
        }} submitText="Odeslat zprávu" successMessage="Děkujeme za vaši zprávu! Ozveme se vám co nejdříve.">
            <ContactFormFields />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function ContactFormFields() {
  const [selectedSubject, setSelectedSubject] = useState("");
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-secondary/50 border border-primary/20 rounded-lg">
        <p className="text-foreground text-lg mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="w-full">
          Odeslat další zprávu
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-6">
        <FormField control={control} name="name" rules={{
        required: "Jméno a příjmení je povinné"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sm uppercase tracking-wider text-muted-foreground">
                Jméno a příjmení
              </FormLabel>
              <FormControl>
                <Input placeholder="Jan Novák" {...field} className="border-[0.5px] border-muted focus-visible:border-primary focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary/50 transition-all duration-200" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "E-mailová adresa je povinná",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Neplatná e-mailová adresa"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sm uppercase tracking-wider text-muted-foreground">
                E-mailová adresa
              </FormLabel>
              <FormControl>
                <Input type="email" placeholder="jan.novak@example.com" {...field} className="border-[0.5px] border-muted focus-visible:border-primary focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary/50 transition-all duration-200" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        pattern: {
          value: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
          message: "Neplatné telefonní číslo"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sm uppercase tracking-wider text-muted-foreground">
                Telefonní číslo (volitelné)
              </FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+420 123 456 789" {...field} className="border-[0.5px] border-muted focus-visible:border-primary focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary/50 transition-all duration-200" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="subject" rules={{
        required: "Předmět zprávy je povinný"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sm uppercase tracking-wider text-muted-foreground">
                Předmět zprávy
              </FormLabel>
              <FormControl>
                <select {...field} onChange={e => {
            field.onChange(e);
            setSelectedSubject(e.target.value);
          }} className="flex h-10 w-full rounded-md border-[0.5px] border-muted bg-black text-white px-3 py-1 text-base shadow-xs transition-all outline-none focus-visible:border-primary focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary/50 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm appearance-none">
                  <option value="" disabled>Vyberte předmět</option>
                  <option value="Dotaz na fotovoltaiku">Dotaz na fotovoltaiku</option>
                  <option value="Vysokotlaké čištění střechy">Vysokotlaké čištění střechy</option>
                  <option value="Impregnace a údržba">Impregnace a údržba</option>
                  <option value="Čištění fasád a okapů">Čištění fasád a okapů</option>
                  <option value="Jiná poptávka">Jiná poptávka</option>
                </select>
              </FormControl>
              <div className={selectedSubject ? "block" : "hidden"}>
                <div className="mt-2 p-3 bg-primary/5 border border-primary/20 rounded-md flex items-start gap-3 animate-fade-in-up">
                  <Info className="size-4 text-primary mt-0.5 shrink-0" />
                  <p className="text-xs text-muted-foreground leading-relaxed">
                    Vybrali jste předmět: <span className="text-primary font-medium">{selectedSubject}</span>. 
                    Naši specialisté se na tento typ poptávky zaměří a připraví pro vás relevantní informace.
                  </p>
                </div>
              </div>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="message" rules={{
        required: "Zpráva je povinná",
        minLength: {
          value: 20,
          message: "Zpráva musí obsahovat alespoň 20 znaků"
        },
        maxLength: {
          value: 2000,
          message: "Zpráva může obsahovat maximálně 2000 znaků"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sm uppercase tracking-wider text-muted-foreground">
                Zpráva
              </FormLabel>
              <FormControl>
                <textarea {...field} placeholder="Popište vaši poptávku nebo dotaz…" rows={6} className="flex w-full rounded-md border-[0.5px] border-muted bg-transparent px-3 py-2 text-base shadow-xs transition-all outline-none focus-visible:border-primary focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary/50 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
            <p className="text-destructive text-sm">{submitError}</p>
          </div>}

        <Button id="odeslat_zpravu" type="submit" disabled={isSubmitting} className="w-full bg-primary text-foreground-primary hover:bg-primary-hover active:scale-[0.98] transition-all duration-200 uppercase tracking-wider font-semibold py-6">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Odesílám...
            </> : "Odeslat zprávu"}
        </Button>
      </div>
    </Form>;
}